(() => {
  const header = document.querySelector('[data-pas-header]');
  if (!header) return;

  const menuToggle = header.querySelector('[data-pas-toggle]');
  const infoToggle = header.querySelector('[data-pas-info-toggle]');
  const overlay = header.querySelector('[data-pas-overlay]');
  const noticeText = header.querySelector('[data-pas-notice-text]');

  const closeAll = () => {
    header.classList.remove('is-open', 'info-open');
    header.querySelectorAll('.pas-header__menu > li.is-open').forEach((item) => {
      item.classList.remove('is-open');
    });
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    if (infoToggle) infoToggle.setAttribute('aria-expanded', 'false');
  };

  if (menuToggle) {
    menuToggle.addEventListener('click', () => {
      const isOpen = header.classList.toggle('is-open');
      header.classList.remove('info-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
      if (infoToggle) infoToggle.setAttribute('aria-expanded', 'false');
    });
  }

  if (infoToggle) {
    infoToggle.addEventListener('click', () => {
      const isOpen = header.classList.toggle('info-open');
      header.classList.remove('is-open');
      infoToggle.setAttribute('aria-expanded', String(isOpen));
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    });
  }

  if (overlay) overlay.addEventListener('click', closeAll);

  header.querySelectorAll('.pas-header__menu a').forEach((link) => {
    link.addEventListener('click', closeAll);
  });

  header.querySelectorAll('[data-pas-submenu-toggle]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const item = button.closest('li');
      if (!item) return;
      const isOpen = item.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(isOpen));
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });

  if (noticeText) {
    const services = [
      'Gullservice',
      'Firehjulskontroll',
      'EU-kontroll og Etterkontroll',
      'Aircondition-service'
    ];
    let index = 0;

    setInterval(() => {
      noticeText.classList.add('is-changing');
      setTimeout(() => {
        index = (index + 1) % services.length;
        noticeText.textContent = services[index];
        noticeText.classList.remove('is-changing');
      }, 350);
    }, 5500);
  }
})();
